import moment from 'moment';
import getAnneeSemaineFromDate from '@/services/general/getAnneeSemaineFromDate';
import getFacesReseauAsync from './getFaces';

export default async function getReseauAvecFaces(reseau, dateDeVisualisation) {
  const dateVisualisation = moment(dateDeVisualisation).format('YYYYMMDD');
  const query = {
    params: {
      dateVisualisation,
      anneeSemaine: getAnneeSemaineFromDate(dateVisualisation),
      jourDepart: reseau.jourDepart,
      societeId: reseau.socCode,
    },
  };
  const listeFaces = await getFacesReseauAsync(reseau.num, query, reseau.listeFaces);
  return Object.assign({}, reseau, { listeFaces });
}



// WEBPACK FOOTER //
// ./src/services/reseauxTempo/getReseauAvecFaces.js